import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal, GoldLine } from "@/components/Reveal";
import { FAQS, waLink, WA_MESSAGES } from "@/config/site";

const Faq = () => {
    const [open, setOpen] = useState(0);
    return (
        <main className="pt-32 sm:pt-40 pb-24 min-h-screen">
            <Seo
                title="FAQs — BSK Jewellers Amritsar"
                siteName="BSK Jewellers"
                description="Answers about BSK Jewellers, Rani Ka Bagh, Amritsar — bridal and custom jewellery, appointments, hallmarking, exchange, delivery and payment options."
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    mainEntity: FAQS.map((f) => ({
                        "@type": "Question",
                        name: f.q,
                        acceptedAnswer: { "@type": "Answer", text: f.a },
                    })),
                }}
            />
            <div className="max-w-3xl mx-auto px-5 sm:px-8">
                <Reveal>
                    <span className="eyebrow">Questions, Answered</span>
                    <h1 className="font-serif text-4xl sm:text-6xl leading-[1.05] mt-5">
                        Frequently Asked <span className="italic gold-text">Questions</span>
                    </h1>
                    <GoldLine delay={0.15} className="w-20 my-8" />
                </Reveal>
                <div className="divide-y divide-gold/10 border-y border-gold/10" data-testid="faq-list">
                    {FAQS.map((f, i) => (
                        <Reveal key={i} delay={i * 0.03}>
                            <div>
                                <button
                                    onClick={() => setOpen(open === i ? -1 : i)}
                                    data-testid={`faq-question-${i}`}
                                    aria-expanded={open === i}
                                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                                >
                                    <span className={`font-serif text-lg sm:text-xl transition-colors ${open === i ? "text-gold" : "text-ivory group-hover:text-gold"}`}>{f.q}</span>
                                    {open === i ? <Minus size={17} className="text-gold shrink-0" strokeWidth={1.5} /> : <Plus size={17} className="text-sand shrink-0 group-hover:text-gold transition-colors" strokeWidth={1.5} />}
                                </button>
                                <div className={`overflow-hidden transition-all duration-500 ${open === i ? "max-h-60 pb-6" : "max-h-0"}`}>
                                    <p className="text-sm text-sand leading-relaxed max-w-2xl" data-testid={`faq-answer-${i}`}>{f.a}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal>
                    <div className="text-center mt-14">
                        <p className="font-serif italic text-xl text-sand">Still curious about something?</p>
                        <a href={waLink(WA_MESSAGES.general)} target="_blank" rel="noreferrer" data-testid="faq-whatsapp-btn" className="inline-block mt-6 bg-gold text-obsidian text-[11px] tracking-[0.25em] uppercase px-9 py-4 hover:bg-gold-bright transition-colors">
                            Ask Us on WhatsApp
                        </a>
                    </div>
                </Reveal>
            </div>
        </main>
    );
};

export default Faq;
